import angular from "angular";

import ServiceProviderApplicationsModuleRouting from "./service-provider-applications.module.routing";

export default angular
  .module("vt-service-provider-applications", [])
  .config(ServiceProviderApplicationsModuleRouting);
